import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getCurrentUserInfo, isRoleTypeAdmin, isRoleTypeOperator } from 'src/reducers/users/currentUser';

import { withTranslation } from 'react-i18next';
import AdminSettings from './components/AdminSettings';
import OperatorSettings from './components/OperatorSettings';

class Settings extends React.Component {
  state = {
    isModalOpen: false
  };

  render() {
    const { currentUser } = this.props;

    return (
      <div>
        <div className="l-main-title-wrap">
          <h2 className="m-title-main">{this.props.t('components.SideMenu.SideMenu.setting')}</h2>
        </div>
        <div className="l-wrap-l l-contents-wrap">
          {isRoleTypeAdmin(currentUser.roleType) ? (
            <AdminSettings />
          ) : (
            <OperatorSettings />
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(connect(state => ({
  planType: _.get(state, 'currentClient.item.data.planType'),
  currentUser: getCurrentUserInfo(state) || {}
}))(Settings));
